import React from 'react';

import { useAction } from 'core/store/store';

import { makeRegistrationSettingsPickUpSubmitAction } from 'state/registration/actions';

import { PickUpForm, PickUpFormData } from '../../../forms/PickUpForm/PickUpForm';

export interface PickUpDialogProps {
    onClose: () => void;
}

export const PickUpDialog = (props: PickUpDialogProps) => {
    const action = useAction();
    return (
        <PickUpForm
            onSubmit={(data: PickUpFormData) => {
                action(makeRegistrationSettingsPickUpSubmitAction, data);
            }}
            onClose={props.onClose}
        />
    );
};
